import {combineReducers} from '@reduxjs/toolkit';

import {userConferencesConferenceSlice} from './slices/user-conferences-conference.slice';
import {userConferencesLicenseSlice} from './slices/user-conferences-license.slice';
import {userConferencesLicensedUsersSlice} from './slices/user-conferences-licensed-users.slice';
import {userConferencePrimaryManagerSlice} from './slices/user-conferences-primary-manager.slice';
import {userConferencesStateSlice} from './slices/user-conferences-state.slice';
import {userConferencesSlice} from './slices/user-conferences.slice';

export const userConferencesReducer = combineReducers({
    result: userConferencesSlice.reducer,
    state: userConferencesStateSlice.reducer,

    license: userConferencesLicenseSlice.reducer,
    licensedUsers: userConferencesLicensedUsersSlice.reducer,
    primaryManager: userConferencePrimaryManagerSlice.reducer,
    conference: userConferencesConferenceSlice.reducer,
});
